import { EXPERT_TYPE_LABELS } from '@/constants'
import { iso2language, iso2country } from '@/utils/localization/iso'

export const humanizeType = (type) => {
  return EXPERT_TYPE_LABELS[type] || type.replace(/-/g, ' ')
}

const makeIndustryValue = (value) => {
  const forbiddenCharsRegex = new RegExp(/&*,*/g)

  return value
    .replace(forbiddenCharsRegex, '')
    .split(' ')
    .map((item) => item.trim().toLowerCase())
    .filter(Boolean)
    .join('-')
}

export const buildTypes = (experts) => {
  const allTypes = experts
    .reduce((types, expert) => {
      return types.concat(
        expert.types.filter((type) => types.indexOf(type) === -1)
      )
    }, [])
    .filter((type) => EXPERT_TYPE_LABELS[type])
    .map((type) => ({
      VALUE: type,
      LABEL: humanizeType(type) || type,
    }))
    .sort((a, b) => (a.LABEL > b.LABEL ? 1 : -1))

  return allTypes
}

export const buildLanguages = (experts) => {
  const allLanguages = experts
    .reduce((languages, expert) => {
      return languages.concat(
        expert.languages.filter(
          (language) => !languages.includes(language) && language !== 'EN'
        )
      )
    }, [])
    .map((language) => ({
      VALUE: language,
      LABEL: iso2language(language),
    }))
    .sort((a, b) => (a.LABEL > b.LABEL ? 1 : -1))

  // Add English first
  allLanguages.unshift({
    VALUE: 'EN',
    LABEL: iso2language('EN'),
  })

  return allLanguages
}

export const buildCountries = (experts) => {
  let allCountries = experts.reduce((countries, expert) => {
    const country = expert?.country

    if (!country || country === 'US') {
      return countries
    }

    return [...countries, country]
  }, [])

  allCountries = [...new Set(allCountries)]
    .map((country) => ({
      VALUE: country,
      LABEL: iso2country(country),
    }))
    .sort((a, b) => (a.LABEL > b.LABEL ? 1 : -1))

  // Add English first
  allCountries.unshift({
    VALUE: 'US',
    LABEL: iso2country('US'),
  })

  return allCountries
}

export const buildIndustries = (experts) => {
  return experts
    .reduce((industries, expert) => {
      return industries.concat(
        expert.industries.filter(
          (industry) => industries.indexOf(industry) === -1
        )
      )
    }, [])
    .map((industry) => ({
      VALUE: makeIndustryValue(industry),
      LABEL: industry,
    }))
    .sort((a, b) => (a.LABEL > b.LABEL ? 1 : -1))
}
